<template>
  <div>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          Metody leczenia
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          Metody leczenia
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-row v-if="browserSize.sm == true || browserSize.xs == true">
        <v-col cols="12">
          <router-link to="/czaszkowo-krzyzowa">
            <img
              width="200"
              height="150"
              class="iconMargin"
              src="../assets/czaszkowa.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Terapia czaszkowo-krzyżowa
            </div>
            <div class="textCenter iconMargin">
              Terapia czaszkowo-krzyżowa jest delikatną i nieinwazyjną formą
              terapii manualnej, która poprawia naturalne mechanizmy
              autoregulacyjne człowieka.
            </div>
          </router-link>
        </v-col>
        <v-col cols="12">
          <router-link to="/Narzadow-wewnetrznych">
            <img
              width="220"
              height="150"
              class="iconMargin"
              src="../assets/narzady-wewn.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Terapia narządów wewnętrznych
            </div>
            <div class="textCenter iconMargin">
              Prawidłowe funkcjonowanie narządów wewnętrznych takich jak:
              żołądek, wątroba czy jelita, ma istotny wpływ na funkcjonowanie i
              jakość życia człowieka.
            </div>
          </router-link>
        </v-col>
        <v-col cols="12">
          <router-link to="/Narzadu-wzroku">
            <img
              width="220"
              height="150"
              class="iconMargin"
              src="../assets/terapiaW.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Terapia narządu wzroku
            </div>
            <div class="textCenter iconMargin">
              Narząd wzroku to nie tylko nasze oczy, ale cały systemu powięzi
              otulający i oplatający gałkę oczną i mięśnie oka. Istnieje silny
              związek pomiędzy naszym narządem wzroku a układem
              mięśniowo-szkieletowym człowieka.
            </div>
          </router-link>
        </v-col>
        <v-col cols="12">
          <router-link to="/Ortopedyczna">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/knee.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Fizjoterapia ortopedyczna
            </div>
            <div class="textCenter iconMargin">
              Fizjoterapia ortopedyczna związana jest z urazami narządu ruchu w
              obrębie kości, stawów oraz tkanek miękkich. Zajmuje się leczeniem
              dolegliwości bólowych i dysfunkcji stawów, ścięgien i mięśni
              wynikających zarówno z przeciążeń, jak i urazów.
            </div>
          </router-link>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <router-link to="/czaszkowo-krzyzowa">
            <img
              width="200"
              height="150"
              class="iconMargin"
              src="../assets/czaszkowa.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Terapia czaszkowo-krzyżowa
            </div>
            <div class="textCenter iconMargin">
              Terapia czaszkowo-krzyżowa jest delikatną i nieinwazyjną formą
              terapii manualnej, która poprawia naturalne mechanizmy
              autoregulacyjne człowieka.
            </div>
          </router-link>
        </v-col>
        <v-col cols="3">
          <router-link to="/Narzadow-wewnetrznych">
            <img
              width="220"
              height="150"
              class="iconMargin"
              src="../assets/narzady-wewn.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Terapia narządów wewnętrznych
            </div>
            <div class="textCenter iconMargin">
              Prawidłowe funkcjonowanie narządów wewnętrznych takich jak:
              żołądek, wątroba czy jelita, ma istotny wpływ na funkcjonowanie i
              jakość życia człowieka.
            </div>
          </router-link>
        </v-col>
        <v-col cols="3">
          <router-link to="/Narzadu-wzroku">
            <img
              width="220"
              height="150"
              class="iconMargin"
              src="../assets/terapiaW.jpg"
            />
            <div
              class="display-1 minWidth font-weight-black grey--text text-center iconMargin"
            >
              Terapia narządu wzroku
            </div>
            <div class="textCenter iconMargin">
              Narząd wzroku to nie tylko nasze oczy, ale cały systemu powięzi
              otulający i oplatający gałkę oczną i mięśnie oka. Istnieje silny
              związek pomiędzy naszym narządem wzroku a układem
              mięśniowo-szkieletowym człowieka.
            </div>
          </router-link>
        </v-col>

        <v-spacer></v-spacer>
      </v-row>
    </v-row>

    <v-row>
      <v-row v-if="browserSize.sm == true || browserSize.xs == true">
        <v-col cols="12">
          <router-link to="/Metoda-McKenziego">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/mckenzie.png"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Metoda McKenziego
            </div>
            <div class="textCenter iconMargin">
              Metoda ta łączy wiedzę z zakresu anatomii prawidłowej człowieka,
              fizjologii oraz biomechaniki klinicznej. Zastosowanie metody
              polega na pracy na poszczególnych segmentach kręgosłupa.
            </div>
          </router-link>
        </v-col>
        <v-col cols="12">
          <router-link to="/PNF">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/pnf.png"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Metoda PNF
            </div>
            <div class="textCenter iconMargin">
              W metodzie PNF pracuje się w oparciu o wzorce ruchowe oraz prawa
              neurofizjologii. Człowiek, który utracił zdolność wykonywania
              czynności w wyniku wylewu lub urazu, aby odzyskać funkcję
              uszkodzonej części ciała powinien zostać poddany reedukacji
              motorycznej.
            </div>
          </router-link>
        </v-col>
        <v-col cols="12">
          <router-link to="/Anatomy-Trains">
            <img
              width="220"
              height="150"
              class="iconMargin"
              src="../assets/anatomyTrains.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Anatomy Trains
            </div>
            <div class="textCenter iconMargin">
              Taśmy mięśniowe człowieka to system połączonych ze sobą mięśni,
              powięzi i struktur anatomicznych, które tworzą łańcuch
              biokinematyczny. Są to podłużnej ciągłości mięśniowo-powięziowe
              taśmy oplatające ciało człowieka, nadające mu kształt oraz
              wpływające na jego funkcje.
            </div>
          </router-link>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <router-link to="/Ortopedyczna">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/knee.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Fizjoterapia ortopedyczna
            </div>
            <div class="textCenter iconMargin">
              Fizjoterapia ortopedyczna związana jest z urazami narządu ruchu w
              obrębie kości, stawów oraz tkanek miękkich. Zajmuje się leczeniem
              dolegliwości bólowych i dysfunkcji stawów, ścięgien i mięśni
              wynikających zarówno z przeciążeń, jak i urazów.
            </div>
          </router-link>
        </v-col>
        <v-col cols="3">
          <router-link to="/Metoda-McKenziego">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/mckenzie.png"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Metoda McKenziego
            </div>
            <div class="textCenter iconMargin">
              Metoda ta łączy wiedzę z zakresu anatomii prawidłowej człowieka,
              fizjologii oraz biomechaniki klinicznej. Zastosowanie metody
              polega na pracy na poszczególnych segmentach kręgosłupa.
            </div>
          </router-link>
        </v-col>
        <v-col cols="3">
          <router-link to="/PNF">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/pnf.png"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Metoda PNF
            </div>
            <div class="textCenter iconMargin">
              W metodzie PNF pracuje się w oparciu o wzorce ruchowe oraz prawa
              neurofizjologii. Człowiek, który utracił zdolność wykonywania
              czynności w wyniku wylewu lub urazu, aby odzyskać funkcję
              uszkodzonej części ciała powinien zostać poddany reedukacji
              motorycznej.
            </div>
          </router-link>
        </v-col>

        <v-spacer></v-spacer>
      </v-row>
    </v-row>

    <v-row>
      <v-row v-if="browserSize.sm == true || browserSize.xs == true">
        <v-col cols="12">
          <router-link to="/Kaltenborn">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/omt.png"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              OMT Kaltenborn
            </div>
            <div class="textCenter iconMargin">
              W terapii manualnej według Kaltenborna wykorzystuje się
              następujące techniki działania: trakcja, mobilizacja, manipulacja
              oraz mobilizacja tkanek miękkich. Są to techniki pracy
              bezpośrednio na połączeniach stawowych.
            </div>
          </router-link>
        </v-col>

        <v-col cols="12">
          <router-link to="/Kinesiology-Taping">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/Kinesio-Taping.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Kinesiology Taping
            </div>
            <div class="textCenter iconMargin">
              Metoda, w której wykorzystuje się elastyczne plastry. Dzięki
              zastosowaniu techniki mięśniowej, więzadłowej bądź powięziowej
              można uzyskać efekt odciążenia, stabilizacji lub zredukowania
              dolegliwości bólowych zmienionej chorobowo tkanki podskórnej i
              mięśniowej.
            </div>
          </router-link>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <router-link to="/Anatomy-Trains">
            <img
              width="220"
              height="150"
              class="iconMargin"
              src="../assets/anatomyTrains.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Anatomy Trains
            </div>
            <div class="textCenter iconMargin">
              Taśmy mięśniowe człowieka to system połączonych ze sobą mięśni,
              powięzi i struktur anatomicznych, które tworzą łańcuch
              biokinematyczny. Są to podłużnej ciągłości mięśniowo-powięziowe
              taśmy oplatające ciało człowieka, nadające mu kształt oraz
              wpływające na jego funkcje.
            </div>
          </router-link>
        </v-col>
        <v-col cols="3">
          <router-link to="/Kaltenborn">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/omt.png"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              OMT Kaltenborn
            </div>
            <div class="textCenter iconMargin">
              W terapii manualnej według Kaltenborna wykorzystuje się
              następujące techniki działania: trakcja, mobilizacja, manipulacja
              oraz mobilizacja tkanek miękkich. Są to techniki pracy
              bezpośrednio na połączeniach stawowych.
            </div>
          </router-link>
        </v-col>
        <v-col cols="3">
          <router-link to="/Kinesiology-Taping">
            <img
              width="150"
              height="150"
              class="iconMargin"
              src="../assets/Kinesio-Taping.jpg"
            />
            <div
              class="display-1 font-weight-black grey--text text-center iconMargin"
            >
              Kinesiology Taping
            </div>
            <div class="textCenter iconMargin">
              Metoda, w której wykorzystuje się elastyczne plastry. Dzięki
              zastosowaniu techniki mięśniowej, więzadłowej bądź powięziowej
              można uzyskać efekt odciążenia, stabilizacji lub zredukowania
              dolegliwości bólowych zmienionej chorobowo tkanki podskórnej i
              mięśniowej.
            </div>
          </router-link>
        </v-col>

        <v-spacer></v-spacer>
      </v-row>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application .grey--text {
  color: #414149 !important;
}
.infor {
  padding: 40px;
}
.infText {
  margin: auto;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  text-align: justify;
  text-align-last: left;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.textCenter {
  text-align-last: left;
}
.iconMargin {
  margin-bottom: 2vh;
}
h1 {
  margin: auto;
}
a:link,
a:visited {
  color: rgba(0, 0, 0, 0.87) !important;
  text-decoration-line: none;
}
a:hover {
  color: rgba(0, 0, 0, 0.87) !important;
  cursor: pointer;
}
</style>
